exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_z9wQ1 {\n    width: 100%;\n}\n\n.logoWrapper_3xesE {\n    vertical-align: middle;\n    text-align: center;\n}\n\n.imageLogo_2U5Of {\n    max-width: 100%;\n    height: auto;\n    width: 170px;\n    margin: 0;\n}\n\n.radioButtonLabel_3_QKv {\n    margin-left: 8px;\n    cursor: pointer;\n}\n\n.sectionTitle_17yn2 {\n    vertical-align: middle;\n    text-align: center;\n}\n\n.submitBtn_Xl5rT {\n    text-align: center;\n}\n\n.centerText_2cm54 {\n    text-align: center;\n}\n\n.titleTextTop_1V0Xw {\n    margin: 0;\n    font-size: 26px;\n}\n\n.signatureDate_wBffk {\n    margin-top: 20px;\n}\n\n.ifNoSpan_3e2AK {\n    font-size: 12px;\n}\n\n.educationRadioGroup_3Waak {\n    margin-top: 5px;\n}\n\n.educationRadioItem_22MV- {\n    display: inline-block;\n    margin-right: 25px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n\n.educationRadioLabel_PBoHZ {\n    font-weight: bold;\n    margin-bottom: 0;\n    margin-left: 6px;\n    cursor: pointer;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.postSecondaryRow_3cii3 {\n    margin-top: 15px;\n    border-top: 1px solid #eee;\n    padding-top: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_z9wQ1",
	"logoWrapper": "logoWrapper_3xesE",
	"imageLogo": "imageLogo_2U5Of",
	"radioButtonLabel": "radioButtonLabel_3_QKv",
	"sectionTitle": "sectionTitle_17yn2",
	"submitBtn": "submitBtn_Xl5rT",
	"centerText": "centerText_2cm54",
	"titleTextTop": "titleTextTop_1V0Xw",
	"signatureDate": "signatureDate_wBffk",
	"ifNoSpan": "ifNoSpan_3e2AK",
	"educationRadioGroup": "educationRadioGroup_3Waak",
	"educationRadioItem": "educationRadioItem_22MV-",
	"educationRadioLabel": "educationRadioLabel_PBoHZ",
	"postSecondaryRow": "postSecondaryRow_3cii3"
};